import { render, staticRenderFns } from "./userDetailsFilter.vue?vue&type=template&id=c00506d6"
import script from "./userDetailsFilter.vue.ts?vue&type=script&lang=ts&external"
export * from "./userDetailsFilter.vue.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports